module.exports = __webpack_public_path__ + "static/header-beba20a0df9355e487ce1a3bcdbc21f1.jpg";